import React from 'react';
import RequireEvent from '../../components/RequireEvent';
import '../../styles/event.css';
import { choose } from '../../utils/platform';
import { useHeadcount } from './useHeadcount';
import HeadcountDesktop from './Headcount.desktop';
import HeadcountMobile from './Headcount.mobile';

const HeadcountView = choose(HeadcountDesktop, HeadcountMobile);

function HeadcountInner({ event }) {
  const vm = useHeadcount(event);
  if (!vm.isAdmin) {
    return (
      <div>
        <div className="page-head"><h1>Headcount</h1></div>
        <div className="card card-pad empty">Only the Owner or an Event Admin can see the headcount.</div>
      </div>
    );
  }
  return <HeadcountView vm={vm} />;
}

export default function Headcount() {
  return <RequireEvent>{(event) => <HeadcountInner event={event} />}</RequireEvent>;
}
